// ✅ File: src/api/companyBranchHistory.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/branch/company`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

export interface HistoryItem {
  changes: {
    raw: string;
  };
  modified_at: string;
  Modified_by: string;
}

export interface CompanyBranchHistoryResponse {
  company_created_at: string;
  company_history: HistoryItem[];
  branch_history: HistoryItem[];
}

export const fetchCompanyBranchHistory = async (
  contactId: string
): Promise<CompanyBranchHistoryResponse> => {
  try {
    const res = await axios.get(`${BASE_URL}/history/${contactId}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch company branch history");
    throw error;
  }
};